var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbnail)?_c('img',{staticClass:"file-thumbnail",attrs:{"src":_vm.thumbnail,"alt":"thumbnail","data-id":_vm.item.id}}):_c('div',{staticClass:"placeholder-container --placeholder"},[_c('span',{staticClass:"placeholder-preview"})])}
var staticRenderFns = []

export { render, staticRenderFns }